import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const ExpiryWarningBanner = ({ certifications }) => {
  const { t } = useLanguage();
  const today = new Date();
  today?.setHours(0, 0, 0, 0);

  const expired = certifications?.filter(c => {
    const expiry = new Date(c?.expiry_date);
    return expiry < today;
  }) || [];

  const expiringSoon = certifications?.filter(c => {
    const expiry = new Date(c?.expiry_date);
    const diffDays = Math.ceil((expiry - today) / (1000 * 60 * 60 * 24));
    return diffDays >= 0 && diffDays <= 30;
  }) || [];

  if (expired?.length === 0 && expiringSoon?.length === 0) return null;

  return (
    <div className="space-y-3 mb-6">
      {expired?.length > 0 && (
        <div className="flex items-start gap-3 p-4 bg-destructive/10 border border-destructive/30 rounded-lg">
          <div className="flex-shrink-0 mt-0.5">
            <Icon name="XCircle" size={20} color="var(--color-destructive)" />
          </div>
          <div className="flex-1">
            <p className="font-semibold text-destructive text-sm">
              {expired?.length} {t('certExpiredBannerTitle')}{expired?.length !== 1 ? 's' : ''}
            </p>
            <p className="text-sm text-destructive/80 mt-0.5">
              {expired?.slice(0, 3)?.map(c => `${c?.worker?.full_name || 'Unknown'} — ${c?.certificate_type}`)?.join(', ')}
              {expired?.length > 3 ? ` ${t('certAndMore')?.replace('{n}', expired?.length - 3)}` : ''}
            </p>
          </div>
        </div>
      )}
      {expiringSoon?.length > 0 && (
        <div className="flex items-start gap-3 p-4 bg-warning/10 border border-warning/30 rounded-lg">
          <div className="flex-shrink-0 mt-0.5">
            <Icon name="AlertTriangle" size={20} color="var(--color-warning)" />
          </div>
          <div className="flex-1">
            <p className="font-semibold text-warning text-sm">
              {expiringSoon?.length} {t('certExpiringSoonBannerTitle')}{expiringSoon?.length !== 1 ? 's' : ''} {t('certExpiringWithin30')}
            </p>
            <p className="text-sm text-warning/80 mt-0.5">
              {expiringSoon?.slice(0, 3)?.map(c => `${c?.worker?.full_name || 'Unknown'} — ${c?.certificate_type}`)?.join(', ')}
              {expiringSoon?.length > 3 ? ` ${t('certAndMore')?.replace('{n}', expiringSoon?.length - 3)}` : ''}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExpiryWarningBanner;
